import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { GET_BANNER_LIST_REQUEST } from "./type";
import { getBannerListSuccess } from "./action";
import { handleApiCallException } from "../../shared/action";
import { invokeApi } from "../../../helper/axiosHelper";

function* fetchBanners() {
  try {
    const response = yield call(invokeApi, "get", "/bannerList", null);
    if (response && response.status) {
      yield put(getBannerListSuccess(response));
    } else {
      yield put(getBannerListSuccess([]));
      handleApiCallException(response && response.message);
    }
  } catch (error) {
    handleApiCallException(error);
  }
}

function* watchBannerRequest() {
  yield takeLatest(GET_BANNER_LIST_REQUEST, fetchBanners);
}

function* BannerSaga() {
  yield all([fork(watchBannerRequest)]);
}

export default BannerSaga;
